module.exports = __webpack_public_path__ + "public/img/wait.147384b6.gif";